import ComponentName from '@Constant/componentName'
import { MY_REPORT } from '@Constant/behaviorTrack'

const caseReport = [
  {
    component: () => import('../../views/layout/Index.vue'),
    path: '/report',
    redirect: {
      name: ComponentName.caseReport.index
    },
    children: [
      {
        component: () => import('../../views/tool/caseReport/Index/Index.vue'),
        path: 'index',
        name: ComponentName.caseReport.index,
        auth: '*',
        meta: {
          title: '结案报告',
          logAuto: {
            pv: true,
            duration: true,
            source: MY_REPORT.PV
          }
        },
        children: [
          {
            component: () => import('../../views/statistic-new/report/Index.vue'),
            path: 'statistic-new/:id',
            name: ComponentName.caseReport.statisticNew,
            props: true,
            auth: '*',
            meta: {
              title: '投后数据',
              logAuto: {
                pv: true,
                duration: true,
                source: MY_REPORT.MY_REPORT_STATISTIC_PV_NEW,
                reportQuery: ['id']
              }
            }
          }
        ]
      },
      {
        component: () => import('../../views/tool/caseReport/Index/CustomReportDrawer.vue'),
        path: 'create-report',
        name: ComponentName.caseReport.createCustomReport,
        auth: '*'
      }
    ]
  }
]

export default caseReport
